<template>
  <div class="refunds">
    <div class="refunds-container" v-show="amount > 0">
      <div class="refunds-c-top">权益回收需支付：</div>
      <div class="refunds-c-center">
        <span class="icon">￥</span>
        <span class="text">{{ amount }}</span>
        <span class="unit">元</span>
      </div>
      <div class="refunds-c-bottom">
        <van-button class="pay-btn" type="primary" block @click="pay">立即支付</van-button>
      </div>
      <!-- <div class="refunds-c-bottom">
        <span>立即支付</span>
      </div> -->
    </div>
    
    <div v-show="amount == 0">
        <van-empty description="当前没有可支付订单" />
    </div>
  </div>
</template>

<script>
// import { Image as VanImage, Empty } from "vant"
import { getCancelInsuranceInfo } from "api/onLine"
import { wechatAuth } from "api/auth";
import { getUserInfo } from "api/user";

export default {
  data() {
    return {
      imgSrc: require("../../assets/Pay_QrCode.jpg"),
      amount: 0,
      payURL: ''
    }
  },
  mounted() {
    this.auth()
    this.init()
  },
  methods: {
    init() {
      getCancelInsuranceInfo()
        .then(({ status, data }) => {
          if (status === 200) {
            if (data.amount > 0) {
              this.amount = data.amount;
              this.payURL = data.payURL;
            }
          } else {
            this.$toast.fail(data.message || "获取权益回收信息失败");
          }
        })
        .catch((e) => console.log(e))
    },
    auth() {
      let isAuth = this.$getItem("isAuth");
      let code = this.$route.query.code;
      let state = this.$route.query.state;

      if (isAuth == undefined || code != undefined) {
        wechatAuth(code, state).then((res) => {
          this.authCount = 1;
          if (res.status == 200) {
            this.$store.commit("setRegisterStatus", true);
            this.$setItem("isAuth", 1);
            this.getUserInfo();
          } else {
            this.$error(res.message);
          }
        });
      } else {
        this.getUserInfo();
      }
    },
    getUserInfo() {
      var that = this;
      let code = this.$route.query.code;
      let state = this.$route.query.state;
      getUserInfo().then((res) => {
        if (res.status == 200) {
          that.userInfoData = res.data;
          if (that.userInfoData.userPhone != undefined) {
            this.$setItem("userModel", res.data);
            // this.getlist(0);
            that.$push({
              path: "/refunds"
            })
            // this.getWaitPayOrdersCount();
          } else {
            that.$push({
              path: "/register",
            });
          }
          // this.getServerPhone();
        } else if (res.status == 400) {
          if (that.firstOnLoad) {
            that.firstOnLoad = false;
            wechatAuth(code, state).then((res) => {
              this.authCount = 1;
              if (res.status == 200) {
                this.$setItem("isAuth", 1);
                this.getUserInfo();
              }
            });
          }
        } else {
          if (this.authCount < 1) {
            this.$removeItem("isAuth");
            this.auth;
          }
          this.$error(res.message);
        }
      });
    },
    pay() {
      window.location.href = this.payURL;
    }
  },
}
</script>

<style>
.refunds {
  background: linear-gradient(#FC5A56, #FB8883);
  height: 100%;
  padding-top: 25px;
}
.refunds-container {
  height: 80%;
  width: 90%;
  margin: auto;
  background-color: #fff;
  border-radius: 6px;
  position: relative;
}
.refunds-c-top {
  font-size: 18px;
  padding: 15px;
}
.refunds-c-center {
  text-align: center;
}
.refunds-c-center .text{
  font-size: 90px;
}
.refunds-c-bottom {
  position: relative;
  margin: auto;
  top: 25px;
  width: 90%;
}
.pay-btn {
  background-color: #f15a4a;
  border: 1px solid #f15a4a;
}

.payment-tips {
  font-size: 22px;
  text-align: center;
  padding-top: 12px;
  color: #1989fa;
}
.payment-icon {
  vertical-align: text-bottom;
  margin-right: 8px;
}
</style>
